import axios from "axios";

export function getClassTypeList(obj) {
  const config = {
    params: obj,
  };
  return axios.get(process.env.VUE_APP_API_URL + "ClassType/get", config);
}

export function postClassType(data) {
  return axios.post(process.env.VUE_APP_API_URL + "ClassType/add", data);
}

export function updateClassType(data) {
  return axios.put(process.env.VUE_APP_API_URL + "ClassType/update", data);
}

export function deleteClassType(classTypeId) {
  const config = {
    params: {
      classTypeId: classTypeId,
    },
  };
  return axios.delete(process.env.VUE_APP_API_URL + "ClassType/delete", config);
}
